"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOption = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _spacing = require("../../../../constants/spacing");
var _spinner = require("../../../spinner");
const LoadingOptionContainer = (0, _styled.default)("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: ${_spacing.sizes.medium}px;
`;
const LoadingOption = () => {
  return /*#__PURE__*/_react.default.createElement(LoadingOptionContainer, {
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(_spinner.Spinner, {
    size: "medium"
  }));
};
exports.LoadingOption = LoadingOption;
//# sourceMappingURL=LoadingOption.js.map